var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageList.length > 0)?_c('FancyBox',{staticClass:"pa-4",attrs:{"images":_vm.imageList}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }